/**
 * Workflow Service
 */

import { httpClient } from '../http-client';

const API_BASE_URL = '/api/v1';

export const WorkflowService = {
  /**
   */
  async getWorkflowStatus(workflowId: string): Promise<{
    status: 'running' | 'completed' | 'failed' | 'terminated';
    result?: unknown;
  }> {
    try {
      const url = `${API_BASE_URL}/workflows/${workflowId}/status`;
      const response = await httpClient.get<{
        status: 'running' | 'completed' | 'failed' | 'terminated';
        result?: unknown;
      }>(url);
      return response.data;
    } catch (error) {
      console.error('Error getting workflow status:', error);
      throw error;
    }
  },
};
